import {
    all,
    call, put, takeLatest,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { CalibrationDataActions, fetchCalibrationDataSagaActiontype } from './types';
import { calibrationDataServices } from '../../services/calibrationData/calibrationDataServices';
import { getCalibrationDataFailure, getCalibrationDataSuccess } from './actions';

function* fetchCalibrationData(action: fetchCalibrationDataSagaActiontype) {
    const { searchText } = action;
    try {
        const response = yield call(calibrationDataServices.fetchCalibrationData, searchText);
        if (response?.error) {
            yield delay(500);
            yield put(getCalibrationDataFailure(response?.error));
        } else {
            yield put(getCalibrationDataSuccess(response?.tableData));
        }
    } catch (err) {
        yield delay(500);
        yield put(getCalibrationDataFailure(err));
    }
}

function* watchCalibrationDataRequest() {
    yield takeLatest(CalibrationDataActions.CALIBRATION_DATA_REQUEST, fetchCalibrationData);
}

function* rootcalibrationDataSaga() {
    yield all([
        watchCalibrationDataRequest(),
    ]);
}

export default rootcalibrationDataSaga;
